(ns web3.routing.history
  (:require [web3.routing.utils :as routing-u]
            [re-frame.core :as rf]))

(rf/reg-fx
 :history/set
 (fn [uri]
   (.setToken routing-u/history uri)))

(rf/reg-fx
 :history/replace
 (fn [uri]
   (.replaceToken routing-u/history uri)))